import React, { Component } from 'react'

export default class ProductRating extends Component {
	render(){

		let ratingContents = <div className="blank_rating"></div>

		if(this.props.rating){
			ratingContents = (
				<div className="review_stars">
					{/* <img src={require(`../../images/ratings/star-${this.props.rating}.png`)} alt={`${this.props.rating} out of 5`} /> */}
					<img src={`/images/ratings/star-${this.props.rating}.png`} alt={`${this.props.rating} out of 5`} />
				</div>
			)
		}

		return (
			ratingContents
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/product/ProductRating.js